import React, { lazy } from 'react'
import { screens } from '../utils/constants/UIConstants'
import Customers from '../pages/customers/Customers'
import Plants from '../pages/plants/Plants'
import UsersManagement from '../pages/users/UsersManagement'

const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'))
const Tenants = lazy(() => import('../pages/tenant/Tenants'))
const Haulers = lazy(() => import('../pages/hauler/Haulers'))
const Vendors = lazy(() => import('../pages/vendor/Vendors'))
const Product = lazy(() => import('../pages/product/Product'))
const PageNotFound = lazy(() => import('../pages/pageNotFound/PageNotFound'))
const Settings = lazy(() => import('../pages/setting/Settings'))
const Profile = lazy(() => import('../pages/profile/Profile'))

const RoutesConst = [
  {
    path: screens.login,
    main: () => <Dashboard />,
  },
  {
    path: screens.token,
    main: () => <Tenants />,
  },
  {
    path: screens.dashboard,
    main: () => <Dashboard />,
  },
  {
    path: screens.tenants,
    main: () => <Tenants />,
  },
  {
    path: screens.haulers,
    main: () => <Haulers />,
  },
  {
    path: screens.vendors,
    main: () => <Vendors />,
  },
  {
    path: screens.customers,
    main: () => <Customers />,
  },
  {
    path: screens.plants,
    main: () => <Plants />,
  },
  {
    path: screens.product,
    main: () => <Product />,
  },
  {
    path: screens.users,
    main: () => <UsersManagement />,
  },
  {
    path: screens.settings,
    main: () => <Settings />,
  },
  {
    path: screens.profile,
    main: () => (
      <div>
        <Profile />
      </div>
    ),
  },
  {
    path: '*',
    main: () => <PageNotFound />,
  },
]

export default RoutesConst
